import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { persistReducer, persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import localStorage from "redux-persist/lib/storage";
import { USER_REDUCER_ACTIONS } from "./enums";
import { getUserReducerAction } from "./models";
let storageSuffix;
export const UserPersistGate = ({
  store,
  userId,
  children
}) => {
  const {
    current: persistor
  } = useRef( // eslint-disable-next-line
  persistStore(store, {
    manualPersist: true
  }));
  useEffect(() => {
    if (userId) {
      storageSuffix = userId;
    }

    persistor.persist();
    return () => {
      storageSuffix = null;
    }; // eslint-disable-next-line
  }, []);
  useEffect(() => {
    if (userId) {
      storageSuffix = userId;
      persistor.persist();
    } else {
      storageSuffix = null;
    } // eslint-disable-next-line

  }, [userId]);
  return /*#__PURE__*/React.createElement(PersistGate, {
    persistor: persistor,
    children: children
  });
};
UserPersistGate.propTypes = {
  store: PropTypes.object,
  userId: PropTypes.string,
  children: PropTypes.element
};
export const persistUserReducer = ({
  key,
  ...rest
}, defaultReducer) => {
  let persistedReducer;
  return (state, action) => {
    switch (getUserReducerAction(storageSuffix, persistedReducer)) {
      case USER_REDUCER_ACTIONS.INITIALIZE:
        persistedReducer = persistReducer({
          key: key + storageSuffix,
          storage: localStorage,
          ...rest
        }, defaultReducer);
        return persistedReducer(state, action);

      case USER_REDUCER_ACTIONS.RETURN_PERSISTED:
        return persistedReducer(state, action);

      case USER_REDUCER_ACTIONS.CLEAN:
        persistedReducer = undefined;
        return defaultReducer(state, action);

      default:
        return defaultReducer(state, action);
    }
  };
};